import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ComponentStore } from "@ngrx/component-store";
import { Store } from "@ngrx/store";
import {
  app_mst_role_RowClass,
  ClientSidePermissionPricingSchemeRoleLinkContainerModel,
  PricingSchemeService,
  TenantRoleService,
} from "blg-akaun-ts-lib";
import { SessionSelectors } from "../../../../../modules/session/session-controller/selectors";
import { SessionStates } from "../../../../../modules/session/session-controller/states";
import { ViewColumnComponent } from "../../../../../view-column.component";
import { AppConfig } from "../../../../../visa";
import { SubSink } from "subsink2";
import { PermissionFacade } from "../../../facades/permission.facade";
import { PermissionStates } from "../../../permission-controller/root";
import { RolePricingSchemeLinkActions } from "../../../role-pricing-scheme-link-controler/actions";

interface LocalState {
  deactivateReturn: boolean;
}

@Component({
  selector: "app-role-pricing-scheme-link-add",
  templateUrl: "./role-pricing-scheme-link-add.component.html",
  styleUrls: ["./role-pricing-scheme-link-add.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ComponentStore],
})
export class RolePricingSchemeLinkAddComponent extends ViewColumnComponent {
  protected readonly index = 1;
  private localState: LocalState;

  readonly localState$ = this.viewColFacade.selectLocalState(this.index);
  readonly deactivateReturn$ = this.componentStore.select(
    (state) => state.localState.deactivateReturn
  );
  readonly AppletLoginSubjectLink$ = this.sessionStore.select(
    SessionSelectors.selectAppletLoginSubjectLink
  );
  readonly userRank$ = this.sessionStore.select(
    SessionSelectors.selectUserRank
  );

  appletGuid = sessionStorage.getItem("appletGuid");

  prevIndex: number;
  private prevLocalState: any;
  public form: FormGroup;
  private subs = new SubSink();
  newRoleArr: app_mst_role_RowClass[] = [];
  roleArr: app_mst_role_RowClass[] = [];
  newPricingSchemeArr: any[] = [];
  pricingSchemeArr: any[] = [];
  tenantGuid: any;
  rank: any;

  constructor(
    private tenantRoleService: TenantRoleService,
    private pricingSchemeService: PricingSchemeService,
    private viewColFacade: PermissionFacade,
    private fb: FormBuilder,
    private readonly sessionStore: Store<SessionStates>,
    private store: Store<PermissionStates>,
    private readonly componentStore: ComponentStore<{ localState: LocalState }>
  ) {
    super();
  }

  ngOnInit(): void {
    this.subs.sink = this.localState$.subscribe((a) => {
      this.localState = a;
      this.componentStore.setState({ localState: a });
    });
    this.subs.sink = this.viewColFacade.prevIndex$.subscribe(
      (resolve) => (this.prevIndex = resolve)
    );
    this.subs.sink = this.viewColFacade
      .prevLocalState$()
      .subscribe((resolve) => (this.prevLocalState = resolve));

    this.subs.sink = this.AppletLoginSubjectLink$.subscribe((session) => {
      if (session) {
        this.tenantGuid = session.tenant_guid.toString();
      }
    });

    this.subs.sink = this.userRank$.subscribe((rank) => {
      if (rank) {
        this.rank = rank;
      }
    });

    this.form = this.fb.group({
      role: ['',  Validators.compose([Validators.required])],
      pricingScheme: ['',  Validators.compose([Validators.required])],
      currentRole: [''],
      currPricingScheme: [''],
    });

    this.subs.sink = this.tenantRoleService
      .get(AppConfig.apiVisa)
      .subscribe((res) => {
        this.newRoleArr = this.roleArr = res.data.map((d) => d.app_mst_role);
      });

    this.subs.sink = this.pricingSchemeService
      .get(AppConfig.apiVisa)
      .subscribe((res) => {
        this.newPricingSchemeArr = this.pricingSchemeArr = res.data.map(
          (d) => d.bl_fi_mst_pricing_scheme_hdr
        );
      });
  }

  applyRoleFilter(filterValue: string) {
    filterValue = filterValue.trim(); // remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.newRoleArr = this.roleArr.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  applyPricingSchemeFilter(filterValue: string) {
    filterValue = filterValue.trim(); // remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.newPricingSchemeArr = this.pricingSchemeArr.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  onSubmit() {
    let clientSidePermissionPricingSchemeRoleLinkContainerModel: ClientSidePermissionPricingSchemeRoleLinkContainerModel =
      new ClientSidePermissionPricingSchemeRoleLinkContainerModel();

    clientSidePermissionPricingSchemeRoleLinkContainerModel.bl_applet_role_pricing_scheme_link.applet_guid =
      this.appletGuid;
    clientSidePermissionPricingSchemeRoleLinkContainerModel.bl_applet_role_pricing_scheme_link.role_guid =
      this.form.value.role;
    clientSidePermissionPricingSchemeRoleLinkContainerModel.bl_applet_role_pricing_scheme_link.pricing_scheme_guid =
      this.form.value.pricingScheme;
    clientSidePermissionPricingSchemeRoleLinkContainerModel.bl_applet_role_pricing_scheme_link.sales_price_read =
      true;
    clientSidePermissionPricingSchemeRoleLinkContainerModel.bl_applet_role_pricing_scheme_link.sales_price_update =
      true;
    clientSidePermissionPricingSchemeRoleLinkContainerModel.bl_applet_role_pricing_scheme_link.purchase_price_read =
      true;
    clientSidePermissionPricingSchemeRoleLinkContainerModel.bl_applet_role_pricing_scheme_link.purchase_price_update =
      true;

    this.store.dispatch(
      RolePricingSchemeLinkActions.createRolePricingSchemeLinkInit({
        RolePricingSchemeLink:
          clientSidePermissionPricingSchemeRoleLinkContainerModel,
        rank: this.rank,
        tenantGuid: this.tenantGuid,
      })
    );
  }

  onReturn() {
    this.viewColFacade.updateInstance(this.prevIndex, {
      ...this.prevLocalState,
      deactivateAdd: false,
      deactivateList: false,
    });
    this.viewColFacade.onPrev(this.prevIndex);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
